import React from 'react';
import Config from '../../config/Config';

const NotificationCard = ({
	message,
	target: { name, params },
	status,
	handleNotifyClose,
	index,
}) => {
	return (
		<div id={`notifyCard_${index}`} className={`item notifyItem ${status}`}>
			<div className="row NotifyTile NotifyTile--green">
				<div
					onClick={handleNotifyClose}
					data-id={index}
					className="Notify-alert-close"
				>
					×
				</div>
				<div className="col-lg-3 col-xs-12 col-md-4 NotifyTile__icon">
					<img
						src={Config.STORAGEPATH + 'img/courses/' + params['course_id'] + '.png'}
						alt="courseLogo"
					/>
				</div>
				<div className="col-lg-9 col-xs-12 col-md-8 NotifyTile__content">
					<p
						className="NotifyTile__message"
						dangerouslySetInnerHTML={{ __html: message }}
					/>
					<span className="NotificationLinkCourse">{`Go to ${name} page to Manage`}</span>
				</div>
			</div>
		</div>
	);
};

export default NotificationCard;
